export var DeviceEnum;
(function (DeviceEnum) {
    DeviceEnum["SMARTPHONE"] = "Smartphone";
    DeviceEnum["DESKTOP"] = "Desktop";
})(DeviceEnum || (DeviceEnum = {}));
